export default "__VITE_ASSET__e400ac1f__"